import { Icons } from "@/assets/images";
import CustomToolTip from "../extended/ToolTip";
import { Button } from "./button";
import { InputProps } from "../extended/type";
import { Label } from "./label";
import { cn } from "@/shared/utils/utils";

const Input = (props: InputProps): React.ReactElement => {
  const {
    labelName,
    className,
    type,
    placeholder,
    readOnly,
    value,
    required,
    name,
    id,
    defaultValue,
    info,
    warning,
    triggerContent,
    warningTriggerContent,
    percentage,
    errors,
    handleKeyDown,
    onBlur,
    infoLink,
    maxLength,
    ...rest
  } = props;

  return (
    <>
      {labelName && (
        <Label className="mb-1.5">
          {labelName}
          {required && <span className="text-destructive -ml-1">*</span>}
          {info &&
            (infoLink ? (
              <a href={infoLink} target="_blank" rel="noopener noreferrer">
                <img src={Icons.officialIcon} alt="info-icon" />
              </a>
            ) : (
              <CustomToolTip
                triggerChild={
                  <Button variant="info" className="min-w-4" type="button">
                    <img src={Icons.infoIcon} alt="info-icon" />
                  </Button>
                }
                triggerContent={triggerContent}
              />
            ))}
          {warning && (
            <CustomToolTip
              triggerChild={
                <Button variant="info" className="min-w-4" type="button">
                  <img
                    src={Icons.warningIcon}
                    alt="warning-icon"
                    className="warning-icon"
                  />
                </Button>
              }
              triggerContent={warningTriggerContent}
            />
          )}
        </Label>
      )}
      <div className="space-y-1">
        <div className="relative">
          <input
            id={id}
            name={name}
            required={required}
            value={value}
            readOnly={readOnly}
            autoComplete="off"
            type={type ? type : "text"}
            data-slot="input"
            placeholder={placeholder ? placeholder : labelName}
            defaultValue={defaultValue}
            maxLength={maxLength}
            onBlur={onBlur}
            className={cn(
              "w-full min-h-10 text-foreground border border-border px-3.5 placeholder:font-medium rounded-10 text-[14px] font-medium placeholder:text-placeholder placeholder:tracking-wide focus-visible:outline-none focus-visible:border-primary transition-all duration-200 read-only:focus-visible:border-border",
              className,
            )}
            {...rest}
            onKeyDown={handleKeyDown}
          />
          {percentage && (
            <span className="absolute top-1/2 -translate-y-1/2 right-6">%</span>
          )}
        </div>
        {errors && (
          <p className="text-sm leading-tight text-red-500">{errors}</p>
        )}
      </div>
    </>
  );
};

export { Input };
